import { useState } from "react";

    
export default function useForgotPasswordState(initialEmail: string) {
    //@@kg here is a case where there are only a couple of state items,
    // so it may not warrant using a reducer... or should I be consistent?

    // by using a custom hook we could include  other state to work on such as app settings state
    // also this simplifies use of dispatch by providing state methods, this would alleviate the 
    // need to use an enum for the action types
    const [email, setEmailState] = useState<string>(initialEmail);
    const [valid, setValid] = useState(true);

    const setEmail = function(value: string) {
        setEmailState(value);
        setValid(value.length > 0);
    };

    return {
        email,
        valid,
        setEmail,
        setValid,
    };
};
